import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

import { getFormattedDate } from '../../../utils';
import Link from '../../Link';
import TitleLabel from '../../Titles/TitleLabel';

const CardImageBasedLarge = ({
  backgroundColor: _backgroundColor,
  date: _date,
  description,
  image,
  slug,
  tags,
  textColor: _textColor,
  title,
}) => {
  const date = getFormattedDate(_date);

  const backgroundColor =
    _backgroundColor || image?.gatsbyImageData?.backgroundColor;

  const textColor = _textColor;
  return (
    <div
      className="h-full card-image-large-grid"
      style={{
        '--card-image-based-large-background-color': backgroundColor,
        '--card-image-based-large-text-color': textColor,
      }}
    >
      <Link
        className="block lg:col-span-16 sm:col-span-9 sm:h-auto h-60 image-hover"
        to={`/article/${slug}`}
      >
        <GatsbyImage
          alt={title}
          image={getImage(image)}
          style={{ height: '100%' }}
        />
      </Link>
      <div className="bg-[color:var(--card-image-based-large-background-color)] lg:col-span-15 sm:col-span-8 flex flex-col sm:py-8 sm:px-6 lg:px-8 px-8 py-8">
        <TitleLabel
          color="text-[color:var(--card-image-based-large-text-color)]"
          tags={tags}
        />
        <Link
          className="mt-6 sm:mt-2 h-full flex flex-col text-hover text-[color:var(--card-image-based-large-text-color)]"
          to={`/article/${slug}`}
        >
          <h3 className="stink-h3">{title}</h3>
          {description && <p className="mt-4 stink-body-1">{description}</p>}
          {date && <p className="mt-4 sm:mt-auto stink-footnote">{date}</p>}
        </Link>
      </div>
    </div>
  );
};

CardImageBasedLarge.propTypes = {
  backgroundColor: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
  slug: PropTypes.string,
  tags: PropTypes.array,
  textColor: PropTypes.string,
  title: PropTypes.string,
};

export default CardImageBasedLarge;
